import { getApi } from '../apiClient';
import { IUnreadRewardsResponse } from './types';
import { getUnreadRewardsMock, markAllRewardsSeenMock, markRewardSeenMock } from './mock';

/**
 * The endpoints below ship in the backend; the mock in `mock.ts` is kept only
 * as a way to exercise the modal without a badge to earn.
 */
export const USE_MOCK_REWARD_NOTIFICATIONS = false;

export async function getUnreadRewards(): Promise<IUnreadRewardsResponse> {
  if (USE_MOCK_REWARD_NOTIFICATIONS) return getUnreadRewardsMock();

  const { data } = await getApi().get<IUnreadRewardsResponse>('/profile/rewards/unread');

  return data;
}

export async function markRewardSeen(rewardId: number): Promise<void> {
  if (USE_MOCK_REWARD_NOTIFICATIONS) {
    await markRewardSeenMock(rewardId);

    return;
  }

  await getApi().post(`/profile/rewards/${rewardId}/seen`);
}

/**
 * Used when the student opts out: everything still queued is acknowledged in
 * one call so nothing is waiting for them if they turn the setting back on.
 */
export async function markAllRewardsSeen(): Promise<void> {
  if (USE_MOCK_REWARD_NOTIFICATIONS) {
    await markAllRewardsSeenMock();

    return;
  }

  await getApi().post('/profile/rewards/seen');
}
